import { createSelector, createSlice } from '@reduxjs/toolkit';
import translationsJson from '../../../data/translations.json';
import systemLanguagesJson from '../../../data/systemlanguages.json';

export const persistActiveLanguage = ({ activeLanguageId }) => {
	localStorage.setItem('activeLanguageId', JSON.stringify(activeLanguageId));
};

export const getPersistedActiveLanguage = () => {
	const persistedData = localStorage.getItem('activeLanguageId');
	if (persistedData) {
		return JSON.parse(persistedData);
	}
	return '1500';
};

const initialState = {
	systemLanguages: systemLanguagesJson ?? null,
	translations: translationsJson ?? null,
	activeLanguageId: getPersistedActiveLanguage(),
};

const localizationSlice = createSlice({
	name: 'localization',
	initialState,
	reducers: {
		setLocalizations: (state, action) => {
			if (action.payload) {
				state.systemLanguages = action.payload.systemLanguages;
				state.translations = action.payload.translations;
			}
		},
		setActiveLanguageId: (state, action) => {
			if (action.payload) {
				state.activeLanguageId = action.payload.activeLanguageId;
			}
		},
		resetLocalizations: (state) => {
			state.systemLanguages = initialState.systemLanguages;
			state.translations = initialState.translations;
			state.activeLanguageId = getPersistedActiveLanguage();
		},
	},
});

export default localizationSlice.reducer;
export const { setLocalizations, setActiveLanguageId, resetLocalizations } = localizationSlice.actions;

export const selectSystemLanguages = (state) => state.localization.systemLanguages;
export const selectTranslations = (state) => state.localization.translations;
export const selectActiveLanguageId = (state) => state.localization.activeLanguageId;

export const selectDefaultLanguage = createSelector(
	selectSystemLanguages,
	(systemLanguages) => {
		if (systemLanguages) {
			return Object.values(systemLanguages)?.find((systemLanguage) => systemLanguage?.default_language === '1');
		}
		return null;
	},
);

export const selectDefaultLanguageId = createSelector(
	selectDefaultLanguage,
	(defaultLanguage) => defaultLanguage?.id,
);

export const selectActiveLanguage = createSelector(
	selectActiveLanguageId,
	selectDefaultLanguageId,
	(activeLanguageId, defaultLanguageId) => activeLanguageId ?? defaultLanguageId,
);

export const selectSystemLanguage = createSelector(
	selectActiveLanguage,
	selectSystemLanguages,
	(systemLanguageId, allSystemLanguages) => {
		/* eslint-disable-next-line */
		for (const [langCode, lang] of Object.entries(allSystemLanguages)) {
			if (lang?.id === systemLanguageId) {
				return langCode;
			}
		}
		return 'en';
	},
);
